export default "__VITE_ASSET__p$LL1IQ8__"